import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { AttackTypeTooltip } from '../../../components/attack-events-grid/cell-content/attack-type-tooltip'

export interface AttackEventValueTooltipWrapperProps {
  readonly organizationID: string
  readonly attackEventId: string
  readonly attackValue: string
  readonly truncatedValue?: boolean
}

function AttackEventValueTooltipWrapper({
  organizationID,
  attackEventId,
  attackValue,
  truncatedValue
}: AttackEventValueTooltipWrapperProps) {
  if (!organizationID) {
    throw new Error('organizationID is a required prop')
  }
  if (!attackEventId) {
    throw new Error('attackEventId is a required prop')
  }

  return (
    <AttackTypeTooltip
      eventUuid={attackEventId}
      organizationID={organizationID}
      attackValue={attackValue}
      truncatedValue={truncatedValue}
    />
  )
}

export const reactAttackEventValueTooltip = createNgReactBridgeDirective(
  'reactAttackEventValueTooltip',
  [],
  AttackEventValueTooltipWrapper,
  ['organizationID', 'attackEventId', 'attackValue', 'truncatedValue']
)
